// App.js
import { useState, useEffect } from "react";
import { Provider } from "react-redux";
import store from "./store";
import { Toaster } from "../src/components/ui/toast";
import { ToastProvider } from "./hooks/use-toast";
import { TooltipProvider } from "../src/components/ui/tooltip";
import { ThemeProvider } from "../src/contexts/ThemeContext";
import { AppProvider, useApp } from "../src/contexts/AppContext";

import AuthPage from "./features/auth/AuthPage";
import ProtectedRoute from "./routes/protectedRoutes";
import DashboardPage from "../src/features/Dashboard/Dashboard";
import AppointmentDetailPage from "../src/features/Appointment/AppointmentDetailPage";
import InventoryPage from "./features/Inventory/Inventory";
import SettingsPage from "./features/Settings/Settings";
import AvailabilityPage from "./features/Availability/Availability";
import SplashScreen from "./features/auth/Splash";
//import { initializePushNotifications } from "./services/pushNotificationService";
import "./config/firebaseConfig";
import Notifications from "./features/notifications/Notifications";
import AppointmentJobPage from "../src/features/Appointment/AppointmentJobPage";
import { usePushNotifications } from "./hooks/usePushNotifications";

function AppContent() {
  const { isAuthenticated, isCheckingAuth, user } = useApp();
  const [currentPage, setCurrentPage] = useState("dashboard");
  const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
  const { initializePushNotifications } = usePushNotifications();

  useEffect(() => {
    initializePushNotifications();
  }, []);

  if (isCheckingAuth) {
    return <SplashScreen />;
  }

  if (!isAuthenticated) {
    return <AuthPage />;
  }

  const handleNavigate = (page, appointmentId) => {
    setCurrentPage(page);
    if (appointmentId) {
      setSelectedAppointmentId(appointmentId);
    }
  };

  const renderPage = () => {
    switch (currentPage) {
      case "dashboard":
        return <DashboardPage onNavigate={handleNavigate} />;
      case "appointment":
        return selectedAppointmentId ? (
          <AppointmentDetailPage
            appointmentId={selectedAppointmentId}
            onNavigate={handleNavigate}
          />
        ) : (
          <DashboardPage onNavigate={handleNavigate} />
        );
      case "appointmentJob":
        return selectedAppointmentId ? (
          <AppointmentJobPage
            appointmentId={selectedAppointmentId}
            onNavigate={handleNavigate}
            techId={user?.employeeid}
          />
        ) : (
          <DashboardPage onNavigate={handleNavigate} />
        );

      case "inventory":
        return <InventoryPage onNavigate={handleNavigate} />;
      case "availability":
        return <AvailabilityPage onNavigate={handleNavigate} />;
      case "settings":
        return <SettingsPage onNavigate={handleNavigate} />;
      default:
        return <DashboardPage onNavigate={handleNavigate} />;
    }
  };

  return (
    <ProtectedRoute>
      <Notifications technicianId={user?.employeeid} />
      {renderPage()}
    </ProtectedRoute>
  );
}

function App() {
  return (
    <ToastProvider>
      <ThemeProvider>
        <AppProvider>
          <TooltipProvider>
            <Toaster />
            <AppContent />
          </TooltipProvider>
        </AppProvider>
      </ThemeProvider>
    </ToastProvider>
  );
}

export default App;
